import type { PessoaResumoDto } from '@nexital/shared';
import type { PosicaoRemota } from '../../application/colaboracao-store';

type NoBase = { id: string; position: { x: number; y: number }; draggable?: boolean; data: object };

type Colaboracao = {
  /** Uuid de quem está nesta tela: as próprias travas não bloqueiam. */
  eu: string;
  arrastes: Record<string, PosicaoRemota>;
  travas: Record<string, PessoaResumoDto>;
};

/**
 * Aplica aos nós o que os colegas fazem agora (RQ-COL-002, RQ-COL-004): o nó que outra pessoa arrasta ou travou não
 * arrasta e mostra quem está mexendo. A posição fica a do meu layout (ADR-0023): cada um arruma o seu quadro.
 */
export function aplicarColaboracao<N extends NoBase>(nos: N[], { eu, arrastes, travas }: Colaboracao): N[] {
  return nos.map((no) => {
    const dono = arrastes[no.id]?.usuario ?? travas[no.id];
    if (!dono || dono.uuid === eu) return no;
    return {
      ...no,
      draggable: false,
      data: { ...no.data, editandoPor: dono.nome },
    };
  });
}
